const Footer = () => {
    return ( 
        <footer>
            <div className="container">
                <div className="flex-center-footer">
                    <div className="copyright-top">
                        Copyright © 2020 
                        <span className="footer-link">
                            <a href="/">Home4Life</a>
                        </span> 
                        
                        All Rights Reserved.
                    </div>
                    <div className="links-bottom">
                        <img src="" alt="" />
                        <img src="" alt="" />
                        <img src="" alt="" />
                    </div>
                </div>
            </div>
        </footer>
     );
}
 
export default Footer;